import {
  getPage,
  getBindAll,
  getClientPage,
  getDataStatistics,
  getidsDataStatistics,
  carLocation,
  carLocationProvincial,
  operationCondition,
} from '@/api/operationaldataserv'

export default {
  state: {
    state_OperationalData_GetPageResult: null,
    state_OperationalData_GetBindAllResult: null,
    state_OperationalData_GetClientPageResult: null,
    state_OperationalData_GetDataStatisticsResult: null,
    state_OperationalData_GetidsDataStatisticsResult: null,
    state_OperationalData_CarLocationResult: null,
    state_OperationalData_CarLocationProvincialResult: null,
    state_OperationalData_OperationConditionResult: null,
  },
  mutations: {
    SET_OPERATIONALDATA_GETPAGE_RESULT: (state, rst) => {
      state.state_OperationalData_GetPageResult = rst;
    },
    SET_OPERATIONALDATA_GETBINDALL_RESULT: (state, rst) => {
      state.state_OperationalData_GetBindAllResult = rst;
    },
    SET_OPERATIONALDATA_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_OperationalData_GetClientPageResult = rst;
    },
    SET_OPERATIONALDATA_GETDATASTATISTICS_RESULT: (state, rst) => {
      state.state_OperationalData_GetDataStatisticsResult = rst;
    },
    SET_OPERATIONALDATA_GETIDSDATASTATISTICS_RESULT: (state, rst) => {
      state.state_OperationalData_GetidsDataStatisticsResult = rst;
    },
    SET_OPERATIONALDATA_CARLOCATION_RESULT: (state, rst) => {
      state.state_OperationalData_CarLocationResult = rst;
    },
    SET_OPERATIONALDATA_CARLOCATIONPROVINCIAL_RESULT: (state, rst) => {
      state.state_OperationalData_CarLocationProvincialResult = rst;
    },
    SET_OPERATIONALDATA_OPERATIONCONDITION_RESULT: (state, rst) => {
      state.state_OperationalData_OperationConditionResult = rst;
    },
  },
  actions: {
    OperationalDataServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_GetBindAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getBindAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_GETBINDALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_GETBINDALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_GetDataStatistics({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDataStatistics(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_GETDATASTATISTICS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_GETDATASTATISTICS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_GetidsDataStatistics({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getidsDataStatistics(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_GETIDSDATASTATISTICS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_GETIDSDATASTATISTICS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_CarLocation({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        carLocation(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_CARLOCATION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_CARLOCATION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_CarLocationProvincial({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        carLocationProvincial(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_CARLOCATIONPROVINCIAL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_CARLOCATIONPROVINCIAL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OperationalDataServ_OperationCondition({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        operationCondition(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OPERATIONALDATA_OPERATIONCONDITION_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OPERATIONALDATA_OPERATIONCONDITION_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OperationalData_GetPageResult: state => {
      return state.state_OperationalData_GetPageResult;
    },
    get_OperationalData_GetBindAllResult: state => {
      return state.state_OperationalData_GetBindAllResult;
    },
    get_OperationalData_GetClientPageResult: state => {
      return state.state_OperationalData_GetClientPageResult;
    },
    get_OperationalData_GetDataStatisticsResult: state => {
      return state.state_OperationalData_GetDataStatisticsResult;
    },
    get_OperationalData_GetidsDataStatisticsResult: state => {
      return state.state_OperationalData_GetidsDataStatisticsResult;
    },
    get_OperationalData_CarLocationResult: state => {
      return state.state_OperationalData_CarLocationResult;
    },
    get_OperationalData_CarLocationProvincialResult: state => {
      return state.state_OperationalData_CarLocationProvincialResult;
    },
    get_OperationalData_OperationConditionResult: state => {
      return state.state_OperationalData_OperationConditionResult;
    },
  }
}